import { FC, ReactNode } from "react"

import { Stack } from "@mui/material"

// Dialog shows its default Submit unless customActionButtonsSlot is null; the footer is a child instead,
// pulled out to the dialog's edges.
const StepFooter: FC<{ children: ReactNode }> = ({ children }) => (
  <Stack
    direction="row"
    alignItems="center"
    gap={1.25}
    mx={-4}
    mb={-3}
    px={4}
    py={2}
    flexWrap="wrap"
    sx={(theme) => ({
      borderTop: `1px solid ${theme.palette.mockup.primary95}`,
    })}
  >
    {children}
  </Stack>
)

export default StepFooter
